<template>
  <el-dialog
    title="工单详情"
    :visible.sync="dialogVisible"
    @close="closeDialog"
    @open="openDialog"
  >
    <div class="dialog-body">
      <el-form :model="ticketDetail" ref="ticketDetail" label-width="140px">
        <el-form-item prop="email" label="邮箱：">
          {{ ticketDetail.email }}
        </el-form-item>
        <el-form-item prop="typeText" label="工单类型：">
          {{ ticketDetail.typeText }}
        </el-form-item>
        <el-form-item prop="title" label="工单截图：">
          <image-wrapper
            v-for="(url, index) in ticketDetail.__attachUrl"
            :key="index"
            :src="url"
            :inline="true"
          ></image-wrapper>
        </el-form-item>
        <el-form-item prop="note" label="文字资料说明：">
          {{ ticketDetail.note }}
        </el-form-item>
        <el-form-item prop="status" label="状态：" v-if="!editable">
          <el-tag :type="(ticketDetail.__status || {}).color">
            {{ (ticketDetail.__status || {}).text }}
          </el-tag>
        </el-form-item>
        <el-form-item prop="status" label="状态：" v-if="editable">
          <el-select
            :value="ticketDetail.status"
            @change="updateTicketDetail('status', $event)"
            placeholder="请选择"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              :disabled="item.disabled"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="toggleDialogVisible(false)" v-if="editable"
        >取消</el-button
      >
      <el-button type="primary" @click="save('form')" v-if="editable"
        >保存</el-button
      >
      <el-button
        type="primary"
        @click="toggleDialogVisible(false)"
        v-if="!editable"
        >确定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';
import ImageWrapper from 'components/image';
import { STATUS_TYPE } from '../../constants';

export default {
  name: 'TicketDetail',
  props: ['value'],
  data() {
    return {
      dialogVisible: false
    };
  },
  components: {
    ImageWrapper
  },
  methods: {
    ...mapActions('notLoggedInUser', ['detail', 'update']),
    ...mapMutations('notLoggedInUser', ['setTicketDetail']),
    toggleDialogVisible(visible) {
      this.dialogVisible = visible;
    },
    openDialog() {
      this.detail(this.value.id);
    },
    closeDialog() {
      this.$emit('input', null);
    },
    updateTicketDetail(type, value) {
      this.setTicketDetail({
        ...this.ticketDetail,
        [type]: value
      });
    },
    save() {
      this.update(this.ticketDetail).then(() => {
        this.$message({
          message: '保存成功！',
          type: 'success'
        });
        this.toggleDialogVisible(false);
        this.$emit('onUpdated');
      });
    }
  },
  watch: {
    value(data) {
      this.toggleDialogVisible(!!data);
    }
  },
  computed: {
    ...mapState('notLoggedInUser', ['ticketDetail']),
    editable() {
      return this.value ? this.value.status !== 1 : false;
    },
    options() {
      return Object.keys(STATUS_TYPE).map(key => {
        return {
          label: STATUS_TYPE[key].text,
          value: Number(key)
        };
      });
    }
  }
};
</script>

<style lang="less" scoped>
.dialog-body {
  display: flex;
  align-items: stretch;
  .el-form {
    flex: 1;
    padding-right: 20px;
  }
}
</style>
